var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    transform: "translate(-25 -223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    transform: "translate(25 224)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,17H0v-.756A10.248,10.248,0,0,1,6.563,6.681a4.5,4.5,0,0,0,7.8.134A10.728,10.728,0,0,1,21,16.756V17Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19.97084045410156 16.00009155273438 C 19.7111701965332 12.60842514038086 17.71614074707031 9.613697052001953 14.68827342987061 8.067913055419922 C 13.65220260620117 9.291305541992188 12.14189720153809 10.00001049041748 10.50030040740967 10.00001049041748 C 8.812030792236328 10.00001049041748 7.233669757843018 9.224370002746582 6.19965124130249 7.928889274597168 C 4.785979270935059 8.616178512573242 3.573189496994019 9.651143074035645 2.661680221557617 10.95510101318359 C 1.621111750602722 12.44369316101074 1.050106406211853 14.18320274353027 1.003149747848511 16.00009155273438 L 19.97084045410156 16.00009155273438 M 20.99970054626465 17.00009155273438 L 2.731323149873788e-07 17.00009155273438 L 2.731323149873788e-07 16.24411010742188 C 2.731323149873788e-07 14.13316059112549 0.6369802951812744 12.10613059997559 1.84207022190094 10.38217067718506 C 3.020050287246704 8.697020530700684 4.652680397033691 7.417290687561035 6.563470363616943 6.681360721588135 C 7.357640266418457 8.111730575561523 8.865680694580078 9.00001049041748 10.50030040740967 9.00001049041748 C 12.09395027160645 9.00001049041748 13.53656005859375 8.183401107788086 14.35930061340332 6.815600872039795 C 18.39368057250977 8.487290382385254 20.99970054626465 12.38938045501709 20.99970054626465 16.75620079040527 L 20.99970054626465 17.00009155273438 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    transform: "translate(31 223)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/ContactIcon.e85f8b9ee08be91cfa9b2a29d9562434.svg";
export { ForwardRef as ReactComponent };